"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.meteoTakeBall = exports.meteoRerollRoll = exports.meteoPlayerFall = exports.meteoPickUpBall = exports.meteoPassRebound = exports.meteoPassBonus = exports.meteoMaxPassDistance = exports.meteoMaxMA = exports.meteoKO = exports.meteoHasExpulsion = exports.meteoGfi = exports.meteoAttackerStrengthBlitz = exports.METEO = exports.getSeason = exports.getMeteo = void 0;
var METEO;
(function (METEO) {
    METEO[METEO["AUTUMN_LEAF_STREWN_PITCH"] = 1] = "AUTUMN_LEAF_STREWN_PITCH";
    METEO[METEO["AUTUMNAL_CHILL"] = 2] = "AUTUMNAL_CHILL";
    METEO[METEO["POURING_RAIN"] = 3] = "POURING_RAIN";
    METEO[METEO["STRONG_WINDS"] = 4] = "STRONG_WINDS";
    METEO[METEO["COLD_WINDS"] = 5] = "COLD_WINDS";
    METEO[METEO["FREEZING"] = 6] = "FREEZING";
    METEO[METEO["PERFECT_CONDITION"] = 7] = "PERFECT_CONDITION";
    METEO[METEO["HEAVY_SNOW"] = 8] = "HEAVY_SNOW";
    METEO[METEO["BLIZZARD"] = 9] = "BLIZZARD";
    METEO[METEO["MORNING_DEW"] = 10] = "MORNING_DEW";
    METEO[METEO["BLOSSOMING_FLOWERS"] = 11] = "BLOSSOMING_FLOWERS";
    METEO[METEO["MISTY_MORNING"] = 12] = "MISTY_MORNING";
    METEO[METEO["HIGH_WINDS"] = 13] = "HIGH_WINDS";
})(METEO || (exports.METEO = METEO = {}));
var SEASON;
(function (SEASON) {
    SEASON[SEASON["WINTER"] = 1] = "WINTER";
    SEASON[SEASON["SPRING"] = 2] = "SPRING";
    SEASON[SEASON["SUMMER"] = 3] = "SUMMER";
    SEASON[SEASON["AUTUMN"] = 4] = "AUTUMN";
})(SEASON || (SEASON = {}));
const seasons = [
    {
        name: SEASON.SPRING,
        start: new Date(2000, 2, 21),
        end: new Date(2000, 5, 20),
    },
    {
        name: SEASON.SUMMER,
        start: new Date(2000, 5, 21),
        end: new Date(2000, 8, 20),
    },
    {
        name: SEASON.AUTUMN,
        start: new Date(2000, 8, 21),
        end: new Date(2000, 11, 20),
    },
    {
        name: SEASON.WINTER,
        start: new Date(2000, 11, 21),
        end: new Date(2001, 2, 20),
    },
];
/** Checks if a date is within a specified season */
function checkSeason(season, date) {
    let remappedStart = new Date(2000, season.start.getMonth(), season.start.getDate());
    let remappedDate = new Date(2000, date.getMonth(), date.getDate());
    let remappedEnd = new Date(2000, season.end.getMonth(), season.end.getDate());
    if (season.start.getFullYear() === season.end.getFullYear()) {
        return remappedStart <= remappedDate && remappedDate <= remappedEnd;
    }
    else {
        return ((remappedStart <= remappedDate &&
            remappedDate <= new Date(2000, 11, 31)) ||
            (new Date(2000, 0, 1) <= remappedDate && remappedDate <= remappedEnd));
    }
}
function findSeason(seasons, date) {
    for (let i = 0; i < seasons.length; i++) {
        let isInSeason = checkSeason(seasons[i], date);
        if (isInSeason === true) {
            return seasons[i];
        }
    }
    return null;
}
const getSeason = () => {
    const season = findSeason(seasons, new Date());
    if (season) {
        return season.name;
    }
    return null;
};
exports.getSeason = getSeason;
const getMeteo = (value) => {
    const season = getSeason();
    // TODO : SUMMER
    if (season === SEASON.SPRING) {
        switch (value) {
            case 2:
                return METEO.MORNING_DEW;
            case 3:
                return METEO.BLOSSOMING_FLOWERS;
            case 11:
                return METEO.MISTY_MORNING;
            case 12:
                return METEO.HIGH_WINDS;
            default:
                return METEO.PERFECT_CONDITION;
        }
    }
    if (season === SEASON.WINTER) {
        switch (value) {
            case 2:
                return METEO.COLD_WINDS;
            case 3:
                return METEO.FREEZING;
            case 11:
                return METEO.HEAVY_SNOW;
            case 12:
                return METEO.BLIZZARD;
            default:
                return METEO.PERFECT_CONDITION;
        }
    }
    if (season === SEASON.AUTUMN) {
        switch (value) {
            case 2:
                return METEO.AUTUMN_LEAF_STREWN_PITCH;
            case 3:
                return METEO.AUTUMNAL_CHILL;
            case 11:
                return METEO.POURING_RAIN;
            case 12:
                return METEO.STRONG_WINDS;
            default:
                return METEO.PERFECT_CONDITION;
        }
    }
    return METEO.PERFECT_CONDITION;
};
exports.getMeteo = getMeteo;
const meteoAttackerStrengthBlitz = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.HEAVY_SNOW) {
        modif = -1;
    }
    return modif;
};
exports.meteoAttackerStrengthBlitz = meteoAttackerStrengthBlitz;
const meteoPlayerFall = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.AUTUMN_LEAF_STREWN_PITCH) {
        modif = -1;
    }
    if (meteoValue === METEO.FREEZING) {
        modif = 1;
    }
    return modif;
};
exports.meteoPlayerFall = meteoPlayerFall;
const meteoKO = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.AUTUMNAL_CHILL) {
        modif = -1;
    }
    if (meteoValue === METEO.COLD_WINDS) {
        modif = -1;
    }
    return modif;
};
exports.meteoKO = meteoKO;
// only pickup ball interaction
const meteoPickUpBall = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.MORNING_DEW) {
        modif = -1;
    }
    return modif;
};
exports.meteoPickUpBall = meteoPickUpBall;
// All ball interaction
const meteoTakeBall = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.POURING_RAIN) {
        modif = -1;
    }
    return modif;
};
exports.meteoTakeBall = meteoTakeBall;
const meteoPassRebound = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.STRONG_WINDS) {
        modif = 3;
    }
    return modif;
};
exports.meteoPassRebound = meteoPassRebound;
const meteoPassBonus = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.STRONG_WINDS) {
        modif = -1;
    }
    if (meteoValue === METEO.COLD_WINDS) {
        modif = -1;
    }
    return modif;
};
exports.meteoPassBonus = meteoPassBonus;
const meteoGfi = (meteoValue) => {
    let modif = 0;
    if (meteoValue === METEO.BLIZZARD) {
        modif = -1;
    }
    if (meteoValue === METEO.MORNING_DEW) {
        modif = -1;
    }
    return modif;
};
exports.meteoGfi = meteoGfi;
const meteoMaxPassDistance = (meteoValue) => {
    // 3.5, 7, 10.2, 13.1
    let max = 14;
    if (meteoValue === METEO.BLIZZARD || meteoValue === METEO.MISTY_MORNING) {
        max = 7;
    }
    return max;
};
exports.meteoMaxPassDistance = meteoMaxPassDistance;
const meteoHasExpulsion = (meteoValue) => {
    if (meteoValue === METEO.BLOSSOMING_FLOWERS) {
        return false;
    }
    return true;
};
exports.meteoHasExpulsion = meteoHasExpulsion;
const meteoMaxMA = (meteoValue) => {
    if (meteoValue === METEO.MISTY_MORNING) {
        return 6;
    }
    return Infinity;
};
exports.meteoMaxMA = meteoMaxMA;
const meteoRerollRoll = (meteoValue) => {
    if (meteoValue === METEO.HIGH_WINDS) {
        return 2;
    }
    return 1;
};
exports.meteoRerollRoll = meteoRerollRoll;
